module.exports = __webpack_public_path__ + "3b0971434eb4c9086589fad1a9bea3a8.svg";